export const BookTypePillTypes = {
  GAAP: 'P',
  GAAP_TO_STAT: 'G',
  STAT: 'A',
};

export const BookTypePills = [
  { label: 'GAAP', type: BookTypePillTypes.GAAP },
  { label: 'GAAP To STAT', type: BookTypePillTypes.GAAP_TO_STAT },
  { label: 'STAT', type: BookTypePillTypes.STAT },
];

export const AllTabBookTypes = [
  BookTypePillTypes.GAAP_TO_STAT,
  BookTypePillTypes.STAT,
  BookTypePillTypes.GAAP,
];
